/**
@format
@flow
*/
import * as React from 'react';
import { VectorIcon } from '@krispy/vector-icons/web';
import IconData from './data.json';

type Props = $ReadOnly<{|
  /**
  * Heights and widths of the icon.
  * If passes one of these, will override size.
  */
  veryMini?: boolean, // 6px
  mini?: boolean, // 12px
  veryTiny?: boolean, // 16px
  tiny?: boolean, // 20px
  extraSmall?: boolean, // 24px
  small?: boolean, // 36px
  medium?: boolean, // 44px
  large?: boolean, // 68px
  /**
   * Optional prop if using size
   * One of:
   * 'veryMini' | 'mini' | 'veryTiny' | 'tiny' | 'extraSmall' | 'small' | 'medium' | 'large'
   */
  size?: string,
  /**
  * Color of icon.
  */
  color?: string,
  /**
  * Name of the icon type to be used.
  */
  name: string,
|}>;

const Icon = (props: Props): React$Node => {
  const { name, color, size } = props;

  return (
    <VectorIcon
      {...(size && { [size]: true })}
      {...props}
      iconData={IconData}
      name={name}
      color={color}
    />
  );
};

Icon.defaultProps = {
  color: undefined,
};

export default Icon;
